export class OrderedMap<T> {
  //The array allows you to quickly iterate over all the items IN ORDER.
  //This is especially useful in Angular templates.
  //If I knew how to mark this READ ONLY  I would. This thing should only be read, by the
  public array: Array<{key: string, value: T}> = [];

  private map: {[key: string]: {key: string, value: T}} = {};

  constructor(values?: Array<{key: string, value: any}>) {
    this.putAll(values);
  }

  put(key: string, value: T, index?: number): void {
    let item;

    item = this.map[key];

    if (item == null) {
      //If the item does not exist yet, create one.
      item = {
        key: key,
        value: value
      };
      this.map[key] = item;

      if (index == null || index >= this.array.length) {
        this.array.push(item);
      } else {
        if (index < 0) {
          index = 0;
        }

        this.array.splice(index, 0, item);
      }
    } else {
      item.value = value;
      if (index != null && this.array[index] !== item) {
        //They said they want this at a particular index and it's different
        //First, remove it from where it was before....
        this.array.splice(this.array.indexOf(item), 1);
        //Next, splice it in at the index.
        this.array.splice(index, 0, item);
      }
    }
  }

  putAll(values?: Array<{key: string, value: any}>): void {
    if (values != null) {
      values.forEach((token: {key: string, value: any}) => {
        this.put(token.key, token.value);
      });
    }
  }

  /**
   * Gets the value for the key.
   */
  get(key: string): T | undefined {
    let item: {key: string, value: T} = this.map[key];
    if (item != null) {
      let value: T = item.value;
      return value;
    }
  }

  /**
   * Removes the item in the map for the particular key
   * @param key
   * @returns {any} Returns the item removed
   */
  remove(key: string): T | undefined {
    // let item = this.array.find((obj) => {
    //     return obj.key === key;
    // });

    let item = this.map[key];

    if (item != null) {
      this.array.splice(this.array.indexOf(item), 1);
      delete this.map[key];
      return item.value;
    }
  }

  /**
   * Removes all items from the sortable map.
   */
  clear(): void {
    // tslint:disable-next-line:forin
    for (let key in this.map) {
      delete this.map[key];
    }
    this.array.length = 0;
  }

  /**
   * Gets the number of items in the sortable map
   */
  get length(): number {
    return this.array.length;
  }

  /**
   * Gets the key values in standard object form. (Which is essentially a Map).
   */
  getMap(): {[key: string]: T} {
    let map: {[key: string]: T} = {};
    this.array.forEach((item) => {
      map[item.key] = item.value;
    });
    return map;
  }

  /**
   * Gets an array of the values in the map
   */
  values(): Array<T> {
    return this.array.map((item) => {
      return item.value;
    });
  }

  /**
   * Gets the keys of the sortable map.
   */
  keys(): Array<string> {
    return this.array.map((item) => {
      return item.key;
    });
  }

  /**
   * Works just like Array.prototype.forEach
   */
  forEach(callback: (value: T, key: string, index: number) => any): void {
    this.array.forEach((item, index) => {
      callback(item.value, item.key, index);
    });
  }

  /**
   * Works just like Array.prototype.find
   */
  find(callback: (value: T, key?: string, index?: number) => any): { key: string; value: T; } | undefined {
    return this.array.find((item, index) => {
      return callback(item.value, item.key, index);
    });
  }

  /**
   * Gets the first value in the sortable map.
   * Handy for initializing things.
   * @returns {T}
   */
  getFirstValue(): T | undefined {
    if (this.length > 0) {
      return this.array[0].value;
    }
  }

  /**
   * Gets the first key in the sortable map.
   * Handy for initializing UI things.
   * @returns {String}
   */
  getFirstKey(): string | undefined {
    if (this.length > 0) {
      return this.array[0].key;
    }
  }

  /**
   * Gets the value from the OrderedMap at the passed in index.
   * @param index - The index to get the value from.
   * @returns {T} - The value at that index. Undefined if the index does not exist.
   */
  getValueAt(index: number): T | undefined {
    let tuple: { key: string, value: T } | undefined = this.array[index];
    if (tuple != null) {
      return tuple.value;
    }
  }

  /**
   * Gets the index of the value if it exists in the OrderedMap.  Returns -1 otherwise/
   * @param value - The value to search for.
   * @returns {number} - The index of the value if the value exists in the array. -1 otherwise.
   */
  indexOf(value: T): number {
    for (let i = 0; i < this.array.length; i++) {
      if (this.array[i].value === value) {
        return i;
      }
    }
    return -1;
  }
}
